<div class="backdrop">
  <div class="backdrop-content">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center py-3">
      <h4 class="mb-0 d-flex align-items-center">
        <i class="bx bx-file-find me-2"></i>
        Test Report
      </h4>
      <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"
        (click)="activeModal.close('Close')"></button>
    </div>

    <div class="card-body p-0">
      <div class="test-header mt-3">
        <div class="header-card">
          <div class="card-content">
            <div class="header-label">Passing Marks</div>
            <div class="header-value">{{ employeeReport.passingScore }} / {{ employeeReport.totalScore }}</div>
          </div>
        </div>

        <div class="header-card date-card">
          <div class="card-content">
            <div class="date-section">
              <div class="date-row">
                <div class="header-label">Start Date</div>
                <div class="header-label">End Date</div>
              </div>
              <div class="date-row">
                <div class="header-value">{{ employeeReport.startDate | date:'MMM dd, yyyy' }}</div>
                <div class="header-value">{{ employeeReport.endDate | date:'MMM dd, yyyy' }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="header-card">
          <div class="card-content">
            <div class="header-label">Attempts Taken</div>
            <div class="header-value">{{ employeeReport.totalAttempt }} / {{ employeeReport.maxAttempt }}</div>
          </div>
        </div>
      </div>

      <section class="attempts-section">
        <header class="section-header">
          <h3>My Attempts</h3>
          <div class="attempt-badge mb-1">{{ employeeReport.testAttempts.length }}</div>
        </header>

        <div class="attempt-tabs">
          <button 
            *ngFor="let attempt of employeeReport.testAttempts; let i = index" 
            class="attempt-tab" 
            [class.active]="i === selectedTabIndex"
            (click)="selectedTabIndex = i"
            aria-label="'Attempt ' + (i + 1)">
            
            <span>Attempt {{ i + 1 }}</span>
        
            <!-- Only show indicator if active -->
            <div class="tab-indicator" *ngIf="i === selectedTabIndex"></div>
          </button>
        </div>
        

        <div class="attempt-details" *ngIf="employeeReport.testAttempts?.length">
          <ng-container *ngIf="employeeReport.testAttempts[selectedTabIndex] as attempt">
            <article class="detail-card">
              <div class="card-icon-container">
                <div class="card-icon">
                  <i class="bx bx-calendar-event" aria-hidden="true"></i>
                </div>
              </div>
              <div class="card-info">
                <div class="card-label">Attempt Date</div>
                <div class="card-value">{{ attempt.attemptDate | date:'MMM dd, yyyy' }}</div>
              </div>
            </article>

            <article class="detail-card">
              <div class="card-icon-container">
                <div class="card-icon">
                  <i class="bx bx-time" aria-hidden="true"></i>
                </div>
              </div>
              <div class="card-info">
                <div class="card-label">Submission Date</div>
                <div class="card-value">{{ attempt.submissionDate | date:'MMM dd, yyyy' }}</div>
              </div>
            </article>

            <article class="detail-card">
              <div class="card-icon-container">
                <div class="card-icon">
                  <i class="bx bx-task" aria-hidden="true"></i>
                </div>
              </div>
              <div class="card-info">
                <div class="card-label">Marks Obtained</div>
                <div class="card-value">{{ attempt.marksObtained }}</div>
              </div>
            </article>

            <article class="detail-card">
              <div class="card-icon-container">
                <div class="card-icon success">
                  <i class="bx bx-check-circle" aria-hidden="true"></i>
                </div>
              </div>
              <div class="card-info">
                <div class="card-label">Status</div>
                <div class="card-value" [ngClass]="attempt.passed ? 'success' : 'fail'">
                  {{ attempt.passed ? 'Pass' : 'Fail' }}
                </div>
              </div>
            </article>
          </ng-container>
        </div>
      </section>
    </div>
  </div>
</div>
